module.exports = "/_next/static/images/353b10b319a24e2280687b5f221b25f7-chedraui-icon.svg";